// extracted by mini-css-extract-plugin
export default {"navControlsContainer":"IwpSubPageNavigation_navControlsContainer__-lF4O","navControlOverview":"IwpSubPageNavigation_navControlOverview__Xkkv2"};